import styled from 'styled-components'

export const CollapsibleContainer = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.colors.transparent};
  ${({ hideBottomLine }) => !hideBottomLine && `border-bottom: 1px solid white;`}
`

export const CollapsibleDivComponentContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.transparent};
  border: none;
  width: 100%;
`

export const CollapsibleButtonComponentContainer = styled.button.attrs(() => ({
  type: 'button'
}))`
  background-color: ${({ theme }) => theme.colors.transparent};
  border: none;
  width: 100%;
  border-radius: 2pt;
  &:focus-visible {
    box-shadow: 0 0 0 3px ${({ theme }) => theme.colors.black};
  }
`

export const ChildrenWrapper = styled.div.attrs(props => ({
  id: props.childrenWrapperId
}))`
  display: ${({ isVisible }) => (isVisible ? 'block' : 'none')};
  background-color: ${({ theme }) => theme.colors.transparent};
`
